angular.module('unica_notification_template.notification_template_services')

.factory('NotificationTemplatePreviewService', function($http, getBaseApiURL) {

	var notificationTemplatePreviewService = {};

	notificationTemplatePreviewService.preview = function (id, userId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-template/preview/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return notificationTemplatePreviewService;

});